module.exports = __webpack_public_path__ + "static/media/FK.a5e298cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/FK.svg
// module id = 2151
// module chunks = 7